import { render, staticRenderFns } from "./MoreDes.vue?vue&type=template&id=7817222e&scoped=true&"
import script from "./MoreDes.vue?vue&type=script&lang=js&"
export * from "./MoreDes.vue?vue&type=script&lang=js&"
import style0 from "./MoreDes.vue?vue&type=style&index=0&id=7817222e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7817222e",
  null
  
)

export default component.exports